import { loggedInUser } from 'hooks/use-logged-in-user';
import { useTaskService } from 'hooks/services/use-task-service';
import { useQuery } from '@tanstack/react-query';
import { ITaskLookupType } from 'types';

interface TaskPrioritiesCache {
  taskPriorities: ITaskLookupType[];
  isTaskPrioritiesLoading: boolean;
  hasTaskPriorities: boolean;
}

export const useTaskPrioritiesCache = (): TaskPrioritiesCache => {
  const taskService = useTaskService();
  const { isLoggedIn } = loggedInUser.useController();

  const query = useQuery({
    queryKey: ['taskPriorities'],
    queryFn: () => taskService.getTaskPriorities(),
    staleTime: Infinity,
    enabled: isLoggedIn
  });

  const { isLoading: isTaskPrioritiesLoading, data: taskPriorities = [] } = query;

  return {
    isTaskPrioritiesLoading,
    taskPriorities,
    hasTaskPriorities: taskPriorities.length > 0
  };
};
